import { createAsyncThunk } from "@reduxjs/toolkit";
// urls
import * as URLS from "../../urls";
//axios
import axios from "../../utilies/axios";
//_________________________________________________

// GET =>  All ORDERS SERVICE
export const getOrdersService = createAsyncThunk(
  "orders/getOrdersService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.ordersURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

//GET ORDERS AGENT SERVICE
export const getOrdersAgentService = createAsyncThunk(
  "orders/getOrdersAgentService",
  async (params, thunkAPI) => {
    try {
      const response = await axios.get(URLS.ordersAgentURL, {
        params: { ...params },
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// PUT => UPDATE ORDER SERVICE
export const updateOrderStatusService = createAsyncThunk(
  "orders/updateOrderStatusService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(`${URLS.ordersURL}/${data?.id}`, {
        status: data?.status,
        _method: "PUT",
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// PUT => UPDATE ORDER SERVICE
export const updateAgentOrderService = createAsyncThunk(
  "orders/updateAgentOrderService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(`${URLS.ordersAgentURL}/${data?.id}`, {
        status: data?.status,
        _method: "PUT",
      });
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// PUT => UPDATE ORDER SERVICE
export const assignOrderService = createAsyncThunk(
  "orders/assignOrderService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.ordersURL}/${data?.id}`,
        data?.data
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

// PUT => UPDATE ORDER SERVICE
export const assignAgentToCustomerService = createAsyncThunk(
  "orders/assignAgentToCustomerService",
  async (data, thunkAPI) => {

    console.log(data)
    try {
      const response = await axios.post(URLS.agentAssURL, data);
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
// PUT => UPDATE ORDER SERVICE
export const updateOrderAgintService = createAsyncThunk(
  "orders/updateOrderAgintService",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${URLS.ordersAgentURL}/${data?.id}`,
        data?.data
      );
      return response;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
